import { useFeatureAppEnvironment, Dependencies } from 'src/feature-app';

export function useFeatureServices(): Dependencies {
  const { featureServices } = useFeatureAppEnvironment();

  return featureServices;
}
